(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  function updateCartCount() {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        const badges = document.querySelectorAll('[data-cart-count]');
        if (!badges.length) return;

        badges.forEach((badge) => {
          if (cart.item_count > 0) {
            badge.textContent = cart.item_count;
            badge.classList.remove('hidden');
          } else {
            badge.textContent = 0;
            badge.classList.add('hidden');
          }
        });
      });
  }

  document.addEventListener('DOMContentLoaded', updateCartCount);
  document.addEventListener('theme:cart:added', updateCartCount);
  document.addEventListener('theme:cart:updated', updateCartCount);

  } catch(e) { console.error(e); }
})();
})();
